import React from 'react';
import { Avatar, Icon } from '@socialchorus/shared-ui-components';
import { AssistantAction } from '../../assistant';
import { GenericCard } from '../../../models/chatbot/types';
import { convertToActionable } from '../../../lib/action-utils';
import { NavigationReferer } from '../../assistant/assistant-action';
import { convertLegacyAssistantUrl } from '../../../lib/url-utils';

interface GenericRefCardProps {
  card: GenericCard;
}

const GenericRefCard: React.FC<GenericRefCardProps> = ({ card }) => {
  const actionable = convertToActionable(card.action, card.heading);

  // Only add pushState for legacy assistant routes (e.g., /sc4#service/4)
  // This enables proper back button functionality for assistant routes
  // For content links (e.g., /sc4#contents/89), we don't need pushState
  const isLegacyAssistantRoute =
    card.action.type === 'navigation' &&
    convertLegacyAssistantUrl(card.action.navigation.url) !== null;

  return (
    <AssistantAction
      action={actionable}
      className="chatbot__reference-card"
      pushState={
        isLegacyAssistantRoute
          ? { referer: NavigationReferer.INBOX }
          : undefined
      }
      onClick={() => undefined}
    >
      <div className="chatbot__reference-card-content">
        <div className="chatbot__reference-card-body">
          <div className="chatbot__reference-avatar">
            {card.icon ? (
              <Avatar imgSrc={card.icon} size="medium" shape="square" alt="" />
            ) : (
              <Icon size={20} className="chatbot__reference-icon">
                link
              </Icon>
            )}
          </div>
          <div className="chatbot__reference-text">
            <h4 className="chatbot__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="chatbot__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </AssistantAction>
  );
};

export default GenericRefCard;
